import { render, staticRenderFns } from "./FeaturedCategories.vue?vue&type=template&id=2625331a&scoped=true&"
import script from "./FeaturedCategories.vue?vue&type=script&lang=js&"
export * from "./FeaturedCategories.vue?vue&type=script&lang=js&"
import style0 from "./FeaturedCategories.vue?vue&type=style&index=0&id=2625331a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2625331a",
  null
  
)

export default component.exports